import React, { createContext, useContext, ReactNode } from 'react';
import { SharedLogging, consoleLogger } from './types';

const LoggingContext = createContext<SharedLogging>(consoleLogger);

interface LoggingProviderProps {
  logger: SharedLogging;
  children: ReactNode;
}

export function LoggingProvider({ logger, children }: LoggingProviderProps) {
  return (
    <LoggingContext.Provider value={logger}>
      {children}
    </LoggingContext.Provider>
  );
}

export function useSharedLogging(): SharedLogging {
  const logger = useContext(LoggingContext);

  return logger;
}

export { consoleLogger };